import React from "react";
import PropTypes from "prop-types";
import styled from "react-emotion";

const propTypes = {
  query: PropTypes.object.isRequired,
  children: PropTypes.any.isRequired,
};

/**
 * Container for list with right panel.
 * It handles rows width when open / closed.
 */
class ListPanelContainer extends React.Component {
  container = styled("div")`
    transition: width 100ms ease-in-out;
    width: 100%;
    will-change: width;
    ${props =>
      props.open
        ? `
      width: calc(100% - 430px);
    `
        : null};
  `;
  state = { open: this.props.query.panel_id !== undefined };

  componentDidUpdate(oldProps) {
    if (this.props.query.panel_id && !oldProps.query.panel_id) return this.setState({ open: true });
    if (!this.props.query.panel_id && oldProps.query.panel_id)
      return this.setState({ open: false });
  }
  render() {
    return <this.container open={this.state.open}>{this.props.children}</this.container>;
  }
}

ListPanelContainer.propTypes = propTypes;
export default ListPanelContainer;



// WEBPACK FOOTER //
// ./src/components/ui/ListPanelContainer.jsx